import axios from 'axios'
import { useEvent, useState } from 'hooks'
import { debounce } from 'utils'

import { getHighlighterComponents } from './selector'

import { highlighter } from '@/modules/admin/usersEdit/fileRights/highlighter/constant'

type State = {
	links: NodeListOf<HTMLElement> | null
}

export const Highlighter = (() => {
	const { state, setState } = useState<State>()

	const initClick = () => {
		const { links } = state

		if (links === null) {
			return
		}

		links.forEach((element) => {
			const targetUrl = element.getAttribute(highlighter.attribute.url)

			if (targetUrl === null) {
				return
			}

			const change = useEvent(element, 'click')
			change.register(
				debounce(() => {
					element.classList.toggle('active-dir')

					axios.post(targetUrl).catch()
				}),
			)
		})
	}

	const init = () => {
		setState({ ...getHighlighterComponents() })

		initClick()
	}

	return {
		init,
	}
})()
